import styled from 'styled-components';
export var StyledBuyButton = styled.button.withConfig({
  displayName: "partials__StyledBuyButton",
  componentId: "sc-f9851m-0"
})(["white-space:nowrap;", " svg{margin-right:9px;vertical-align:text-bottom;}"], function (_ref) {
  var height = _ref.height;
  return height ? "height: ".concat(height, ";") : '';
});